import React from 'react';
import { Helmet } from 'react-helmet-async';

type ClarityProjectId = 'hvn8o07eqd' | 'lqepsakddd';

const clarityTagUrl = (projectId: ClarityProjectId) => `https://www.clarity.ms/tag/${projectId}`;

/**
 * Microsoft's loader snippet, made safe to run more than once.
 * Helmet re-runs it on every remount (single-page guest layouts remount on scroll), and a second
 * copy of the tag throws once Clarity has stopped itself for lack of consent.
 * `crossOrigin` lets errors from the tag reach New Relic with their real message instead of "Script error.".
 */
const clarityLoaderSnippet = (projectId: ClarityProjectId) => `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        if(l.querySelector(r+'[src="'+i+'"]'))return;
        t=l.createElement(r);t.async=1;t.crossOrigin="anonymous";t.src=i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", ${JSON.stringify(clarityTagUrl(projectId))});`;

/**
 * Rendered through Helmet so SSR pages still start loading Clarity from the server-rendered <head>.
 */
export const ClarityLoaderScript = ({ projectId }: Readonly<{ projectId: ClarityProjectId }>) => (
  <Helmet>
    <script type="text/javascript">{clarityLoaderSnippet(projectId)}</script>
  </Helmet>
);
